import { render } from "./TopHeader.vue?vue&type=template&id=8faf23b0&scoped=true"
const script = {}

import "./TopHeader.vue?vue&type=style&index=0&id=8faf23b0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8faf23b0"]])

export default __exports__